import { Button, Group, Stack, TextInput, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';

import { objectionResponsesTypes } from '../types';

type Props = {
  initial?: Partial<objectionResponsesTypes.ObjectionResponse>;
  aiId: number;
  onSubmit: (values: { aiId: number; objectionText: string; responseText: string }) => void;
  submitLabel: string;
  isSubmitting?: boolean;
};

export const ObjectionResponseForm = ({
  initial,
  aiId,
  onSubmit,
  submitLabel,
  isSubmitting,
}: Props) => {
  const form = useForm({
    initialValues: {
      objectionText: initial?.objectionText ?? '',
      responseText: initial?.responseText ?? '',
    },
    validate: {
      objectionText: (value) => (!value.trim() ? 'This field is required' : null),
      responseText: (value) => (!value.trim() ? 'This field is required' : null),
    },
  });

  return (
    <form
      onSubmit={form.onSubmit((values) =>
        onSubmit({
          aiId,
          objectionText: values.objectionText,
          responseText: values.responseText,
        })
      )}
    >
      <Stack gap="sm">
        <TextInput label="User message (objection)" {...form.getInputProps('objectionText')} />
        <Textarea
          label="Recommended response"
          autosize
          minRows={3}
          {...form.getInputProps('responseText')}
        />
        <Group justify="flex-end" mt="md">
          <Button type="submit" loading={isSubmitting}>
            {submitLabel}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};
